/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  updatePassword(id, data) {
    return axios.patch(`${this.url}/${id}/password`, data);
  }
}

export default new Agents();
